export const GENDER_LIST = [
	{
		title: 'Männlich',
		value: 'Male'
	},
	{
		title: 'Weiblich',
		value: 'Female'
	},
	{
		title: 'Divers/Non-binary',
		value: 'Diverse'
	}
]

export const CHAT_POLL_TIME = 15000
export const CHAT_COUNT_POLL_TIME = 45000
export const CHAT_SEEN_DELAY = 1000

export const INPUT_MAX_LENGTH = 500

export const PAGE_SIZE = 20
export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50, 100]

export const APP_VERSION_POLL_TIME = 1000 * 60 * 5
export const APP_VERSION_INITIAL_DELAY = 1000 * 60

export const ValidationRegex: Record<string, RegExp> = {
	characters: /[!+/@#$%^&*(),.?±~`":{}|<>]+/,
	lowercase: /[a-z]+/,
	uppercase: /[A-Z]+/,
	numeric: /[0-9]+/
}
